import table_messages from 'messages/table_messages';
import { StaticTableFilter } from 'types/TableFilter';

import booleanDictionary from '../../booleanDictionary';

const identifiableInformationFilter: StaticTableFilter = {
  isDynamic: false,
  sectionName: table_messages.assets_filters.identifiable_information,
  filters: booleanDictionary,
  isSingleSelect: true,
};

export default identifiableInformationFilter;
